import React from 'react'

export default function TherapistSaleReport() {
    return (
        <div>TherapistSaleReport</div>
    )
}
